module.exports = __webpack_public_path__ + "img/二维码.18f00834.jpg";